import type { SVGProps } from "react";

export default function ImportIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.8332 18.3327C14.2124 18.3266 15.9819 18.2437 17.1127 17.1127C18.3332 15.8924 18.3332 13.9282 18.3332 9.99984C18.3332 6.07146 18.3332 4.10728 17.1127 2.8869C15.8924 1.6665 13.9282 1.6665 9.99983 1.6665C6.07148 1.6665 4.10728 1.6665 2.8869 2.8869C1.75603 4.01775 1.67308 5.78728 1.66699 9.1665"
        stroke="#F4F4F4"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M2.5 17.5002L9.16667 10.8335M9.16667 10.8335H4.16667M9.16667 10.8335V15.8335"
        stroke="#F4F4F4"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
